import * as React from "react";
import { twMerge } from "tailwind-merge";
import Button, { ButtonColor } from "./Button";
import { SVGs } from "../assets";
import InputContainer from "./InputContainer";

export type ChipSelectorOption = {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
};

export type ChipSelectorProps = {
  label?: string;
  options: ReadonlyArray<ChipSelectorOption>;
  value?: string | number;
  onChange?: (value: string | number) => void;
  onSelectedClick?: (value: string | number) => void;
  required?: boolean;
  errorMessage?: string;
  className?: string;
  color?: ButtonColor;
};

export default function ChipSelector({
  label,
  options,
  value,
  onChange,
  onSelectedClick,
  required,
  errorMessage,
  className,
  color = "secondary",
}: ChipSelectorProps) {
  return (
    <InputContainer
      label={label}
      required={required}
      errorMessage={errorMessage}
      className={twMerge("flex flex-col gap-2", className)}
      classNames={{
        container: "[all:unset]",
      }}
    >
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isSelected = opt.value === value;
          return (
            <Button
              color={color}
              key={opt.value}
              variant="outline"
              children={opt.label}
              aria-pressed={isSelected}
              onClick={() =>
                isSelected ? onSelectedClick?.(opt.value) : onChange?.(opt.value)
              }
              className={twMerge(isSelected && "bg-background")}
              icon={
                opt.icon ?? (isSelected && <img src={SVGs.check} alt="check" />)
              }
              iconPosition="right"
            />
          );
        })}
      </div>
    </InputContainer>
  );
}
